module.exports = __webpack_public_path__ + "static/media/account-icon.4f06415a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/account-icon.svg
// module id = 98
// module chunks = 0